import { parseForce, parsePressure, parseLength } from "../../utils/units.js";

class LoadDialogComponent extends HTMLElement {

  columnDeadLoad = 400 // kips
  columnLiveLoad = 270 // kips
  floorLoad = 100 // lbs/ft^2
  floorSlabThickness = 6 // inches
  floorDensity = 150 // lbs/ft^3
  fillDepth = 6 // inches
  fillSlabDensity = 100 // lbs/ft^3
  

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail), true)
    this.addEventListener('show.bs.modal', this.configure)
  }

  /**
   * Create our view model and configure the view
   * @param {Load} model
   * 
   */
   onProjectLoaded(model) {
    this.columnDeadLoad = model.load.columnDeadLoad
    this.columnLiveLoad = model.load.columnLiveLoad
    this.floorLoad = model.load.floorLoad
    this.floorSlabThickness = model.load.floorSlabThickness
    this.floorSlabDensity = model.load.floorSlabDensity
    this.fillDepth = model.load.fillDepth
    this.fillDensity = model.load.fillDensity
    this.configure()    
  }

  configure() {
    document.getElementById('column-dead-load-input').value = this.columnDeadLoad
    document.getElementById('column-live-load-input').value = this.columnLiveLoad
    document.getElementById('floor-load-input').value = this.floorLoad
    document.getElementById('floor-thickness-input').value = this.floorSlabThickness
    document.getElementById('floor-density-input').value = this.floorSlabDensity
    document.getElementById('fill-depth-input').value = this.fillDepth
    document.getElementById('fill-density-input').value = this.fillDensity
  }

  publishUpdate() {
    this.configure()
    const event = new CustomEvent('load-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onColumnDeadLoadBlur() {
    const value = parseForce(document.getElementById("column-dead-load-input").value)
    if(isNaN(value)) {
      document.getElementById('column-dead-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('column-dead-load-validation').classList.add('d-none') 
    this.columnDeadLoad = value
    this.publishUpdate()
  }

  onColumnLiveLoadBlur() {
    const value = parseForce(document.getElementById("column-live-load-input").value)
    if(isNaN(value)) {
      document.getElementById('column-live-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('column-live-load-validation').classList.add('d-none') 
    this.columnLiveLoad = value
    this.publishUpdate()
  }

  onFloorLoadBlur() {
    const value = parsePressure(document.getElementById("floor-load-input").value)
    if(isNaN(value)) {
      document.getElementById('floor-load-validation').classList.remove('d-none')
      return
    }
    document.getElementById('floor-load-validation').classList.add('d-none') 
    this.floorLoad = value
    this.publishUpdate()
  }

  onFloorSlabThicknessBlur() {
    const value = parseLength(document.getElementById("floor-thickness-input").value)
    if(isNaN(value)) {
      document.getElementById('floor-thickness-validation').classList.remove('d-none')
      return
    }
    document.getElementById('floor-thickness-validation').classList.add('d-none') 
    this.floorSlabThickness = value
    this.publishUpdate()
  }

  onFloorSlabDensityBlur() {
    const value = parseInt(document.getElementById("floor-density-input").value)
    if(isNaN(value)) {
      document.getElementById('floor-density-validation').classList.remove('d-none')
      return
    }
    document.getElementById('floor-density-validation').classList.add('d-none') 
    this.floorSlabDensity = value
    this.publishUpdate()
  }

  onFillDepthBlur() {
    const value = parseLength(document.getElementById("fill-depth-input").value)
    if(isNaN(value)) {
      document.getElementById('fill-depth-validation').classList.remove('d-none')
      return
    }
    document.getElementById('fill-depth-validation').classList.add('d-none') 
    this.fillDepth = value
    this.publishUpdate()
  }

  onFillDensityBlur() {
    const value = parseInt(document.getElementById("fill-density-input").value)
    if(isNaN(value)) {
      document.getElementById('fill-density-validation').classList.remove('d-none')
      return
    }
    document.getElementById('fill-density-validation').classList.add('d-none') 
    this.fillDensity = value
    this.publishUpdate()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-load-dialog" tabindex="-1" role="dialog" aria-labelledby="modal-load-dialog"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Footing Loads</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="bs-component">
              <!-- Table -->
              <form id="load-form">
                <div>
                  <table class="table">
                    <tr id='column-dead-load-input-row'>
                      <td style="width:200px;">Column Dead Load (<em>D</em>)</td>
                      <td><input style="width:100px;" id="column-dead-load-input" type="text" name="column-dead-load"
                          class="text-center" value="${this.columnDeadLoad}" /> kips
                          <div  style="width:200px;" id="column-dead-load-validation" class="alert alert-danger d-none">
                            Please enter a valid load. e.g. 5 or 5 kips
                          </div>
                      </td>
                    </tr>
                    
                    <tr id='column-live-load-input-row'>
                      <td style="width:200px;">Column Live Load (<em>L</em>)</td>
                      <td><input style="width:100px;" id="column-live-load-input" type="text" name="column-live-load"
                      class="text-center" value="${this.columnLiveLoad}" /> kips
                      <div  style="width:200px;" id="column-live-load-validation" class="alert alert-danger d-none">
                        Please enter a valid load. e.g. 5 or 5 kips
                      </div>
                      </td>
                    </tr>

                    <tr id='floor-load-input-row'>
                      <td style="width:200px;">Floor Load</td>
                      <td><input style="width:100px;" id="floor-load-input" type="text" name="floor-load"
                      class="text-center" value="${this.floorLoad}" /> psf
                      <div  style="width:200px;" id="floor-load-validation" class="alert alert-danger d-none">
                        Please enter a valid load. e.g. 100 or 100 psf
                      </div>
                      </td>
                    </tr>
                    
                    <tr>
                      <td style="width:200px;">Floor Slab Thickness (<em>t<sub>floor</sub></em>)</td>
                      <td><input style="width:100px;" id="floor-thickness-input" type="text" name="floor-thickness-load"
                      class="text-center" value="${this.floorSlabThickness}" /> inches
                      <div  style="width:200px;" id="floor-thickness-validation" class="alert alert-danger d-none">
                        Please enter a valid depth. e.g. 12 or 12 in
                      </div>
                      </td>
                    </tr>

                    <tr>
                      <td style="width:200px;">Floor Slab Density (<em>&gamma;<sub>floor</sub></em>)</td>
                      <td><input style="width:100px;" id="floor-density-input" type="text" name="floor-density-load"
                      class="text-center" value="${this.floorSlabDensity}" /> lb/ft<sup>3</sup>
                      <div  style="width:200px;" id="floor-density-validation" class="alert alert-danger d-none">
                        Please enter a valid depth. e.g. 100
                      </div>
                      </td>
                    </tr>

                    <tr>
                      <td style="width:200px;">Fill Depth (<em>t<sub>fill</sub></em>)</td>
                      <td><input style="width:100px;" id="fill-depth-input" type="text" name="fill-depth-load"
                      class="text-center" value="${this.fillDepth}" /> inches
                      <div  style="width:200px;" id="fill-depth-validation" class="alert alert-danger d-none">
                        Please enter a valid depth. e.g. 12 or 12 in
                      </div>
                      </td>
                    </tr>

                    <tr>
                      <td style="width:200px;">Fill Density (<em>&gamma;<sub>fill</sub></em>)</td>
                      <td><input style="width:100px;" id="fill-density-input" type="text" name="fill-density-load"
                      class="text-center" value="${this.fillDensity}" /> lb/ft<sup>3</sup>
                      <div  style="width:200px;" id="fill-density-validation" class="alert alert-danger d-none">
                        Please enter a valid depth. e.g. 100
                      </div>
                      </td>
                    </tr>

                  </table>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById('column-live-load-input').onblur = (() => this.onColumnLiveLoadBlur())
    document.getElementById('column-dead-load-input').onblur = (() => this.onColumnDeadLoadBlur())
    document.getElementById('floor-load-input').onblur = (() => this.onFloorLoadBlur())
    document.getElementById('floor-thickness-input').onblur = (() => this.onFloorSlabThicknessBlur())
    document.getElementById('floor-density-input').onblur = (() => this.onFloorSlabDensityBlur())
    document.getElementById('fill-depth-input').onblur = (() => this.onFillDepthBlur())
    document.getElementById('fill-density-input').onblur = (() => this.onFillDensityBlur())

    this.configure()
  }
}

customElements.define('load-dialog-component', LoadDialogComponent)